import { render, staticRenderFns } from "./ContractHeaderDetail.vue?vue&type=template&id=672c9b1a&"
import script from "./ContractHeaderDetail.vue?vue&type=script&lang=js&"
export * from "./ContractHeaderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports